<div>
    <!--START DISPLAY MODES 0 and 1 - Standard calculations with name on left and cost on right-->
    <div *ngIf="isPriceTaxBreakdown || isCustomerOmitting" class="container-fluid">
        <div class="row font-weight-bold mb-3 pb-1">
            <div class="col-1">
                <div *ngIf="isCustomerOmitting" class="d-inline-block">
                    <div class="ml-n2">Omit</div>
                </div>
            </div>
            <div class="col">
                <div *ngIf="isCustomerOmitting" class="d-inline-block ml-4 pl-1">
                    Name
                </div>
                <div *ngIf="isPriceTaxBreakdown" class="d-inline-block">Name</div>
            </div>
            <div class="col text-right">Amount</div>
        </div>

        <!--Top row for Cost/Retail Price - Display mode 0 and 1-->
        <div class="row mb-3">
            <div *ngIf="isCustomerOmitting" class="col-1"></div>
            <div class="col ml-4">
                {{ isCostPlus ? "Cost" : "Retail" }}
            </div>
            <div class="col"></div>
            <div class="col text-right">${{ fboPrice | decimalPrecision }}</div>
        </div>

        <!--Above the line taxes - Display mode 0 and 1-->
        <div
            *ngFor="let aboveLineTax of aboveTheLineTaxes"
            class="row font-italic"
            [ngClass]="{
                'faded-text': isOmittedManually(aboveLineTax)
            }"
        >
            <div *ngIf="isCustomerOmitting" class="col-1">
                <mat-checkbox
                    (change)="omitChanged(aboveLineTax)"
                    [(ngModel)]="aboveLineTax.isOmitted"
                    type="checkbox"
                    *ngIf="!isRetailMinus"
                    [disabled]="isMember"
                ></mat-checkbox>
            </div>
            <div class="col ml-4">
                <span
                    [ngClass]="{
                        'strike-through':isTextStrikeThrough(aboveLineTax)
                    }"
                    >{{ aboveLineTax.name }}</span
                >
                <sup
                    class="pl-1"
                    *ngIf="isOmittedManually(aboveLineTax)"
                    >{{ aboveLineTax.omittedFor }}</sup
                >
            </div>
            <div
                [ngClass]="{
                    'strike-through': isTextStrikeThrough(aboveLineTax)
                }"
                class="col text-right"
            >
                <span *ngIf="isCalculationTypePercentage(aboveLineTax)"
                    >{{ aboveLineTax.value | decimalPrecision }}%</span
                >
            </div>
            <div
                [ngClass]="{
                    'strike-through': isTextStrikeThrough(aboveLineTax)
                }"
                class="col text-right"
            >
                <span *ngIf="isCostPlus">{{
                    aboveLineTax.amount | currencyPresicion
                }}</span>
                <span *ngIf="isRetailMinus">Applied</span>
            </div>
        </div>

        <!--Sub-total-->
        <div *ngIf="customerMargin != null" class="row mt-3 mb-3">
            <div *ngIf="isCustomerOmitting" class="col-1"></div>
            <div class="col font-weight-bold ml-4">Sub-total</div>
            <div class="col"></div>
            <div class="col text-right font-weight-bold">
                {{ preMarginSubTotal | currencyPresicion }}
            </div>
        </div>

        <!--ITP Margin-->
        <div *ngIf="customerMargin != null" class="row">
            <div *ngIf="isCustomerOmitting" class="col-1"></div>
            <div class="col ml-4" *ngIf="isCostPlus">ITP-Margin</div>
            <div class="col ml-4" *ngIf="isRetailMinus">Discount</div>
            <div class="col"></div>
            <div class="col text-right">
                <span *ngIf="isRetailMinus">-</span>${{
                    marginITP | decimalPrecision
                }}
            </div>
        </div>

        <!--Sub-total with Margin-->
        <div *ngIf="customerMargin != null" class="row mb-3 mt-3">
            <div *ngIf="isCustomerOmitting" class="col-1"></div>
            <div class="col font-weight-bold ml-4">Sub-total w/ Margin</div>
            <div class="col"></div>
            <div class="col text-right font-weight-bold">
                {{ subTotalWithMargin | currencyPresicion }}
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <hr
                    *ngIf="showLineSeparator"
                    style="margin-bottom: 10px; margin-top: 10px"
                />
            </div>
        </div>

        <!--Below the line taxes - Display mode 0 and 1-->
        <div
            *ngFor="let belowLineTax of belowTheLineTaxes"
            class="row font-italic"
            [ngClass]="{
                'faded-text': isOmittedManually(belowLineTax)
            }"
        >
            <div *ngIf="isCustomerOmitting" class="col-1">
                <mat-checkbox
                    (change)="omitChanged(belowLineTax)"
                    [(ngModel)]="belowLineTax.isOmitted"
                    type="checkbox"
                    [disabled]="isMember"
                ></mat-checkbox>
            </div>
            <div class="col ml-4">
                <span
                    [ngClass]="{
                        'strike-through': isTextStrikeThrough(belowLineTax)
                    }"
                    >{{ belowLineTax.name }}</span
                >
                <sup
                    class="pl-1"
                    *ngIf="isOmittedManually(belowLineTax)"
                    >{{ belowLineTax.omittedFor }}</sup
                >
            </div>
            <div
                [ngClass]="{
                    'strike-through': isTextStrikeThrough(belowLineTax)
                }"
                class="col text-right"
            >
                <span *ngIf="isCalculationTypePercentage(belowLineTax)"
                    >{{ belowLineTax.value | decimalPrecision }}%</span
                >
            </div>
            <div
                [ngClass]="{
                    'strike-through': isTextStrikeThrough(belowLineTax)
                }"
                class="col text-right"
            >
                <span *ngIf="belowLineTax.amount">{{
                    belowLineTax.amount | currencyPresicion
                }}</span>
            </div>
        </div>

        <!--Total-->
        <div *ngIf="customerMargin != null" class="row font-weight-bold mb-3">
            <div *ngIf="isCustomerOmitting" class="col-1"></div>
            <div class="col ml-4">Total</div>
            <div class="col"></div>
            <div class="col text-right">{{ total | currencyPresicion }}</div>
        </div>
    </div>

    <!--START DISPLAY MODE 2 - No margin shown and reverse horizontal order-->
    <div *ngIf="isPricingPanel" class="container-fluid" style="width: 100%">
        <!--Top row for Cost/Retail Price - Display mode 0 and-->
        <div *ngIf="isPricingPanel" class="row font-weight-bold">
            <div class="col-6 label-tax-fees">
                <div class="">${{ fboPrice | decimalPrecision }}</div>
            </div>
            <div class="col-6 label-tax-fees">
                <div class="no-padding-label">
                    {{ isCostPlus ? "Cost" : "Posted Retail" }}
                </div>
            </div>
        </div>

        <!--Above the line taxes - Display mode 2-->
        <div *ngFor="let aboveLineTax of aboveTheLineTaxes" class="row">
            <div class="col-6">
                <div
                    [ngClass]="{
                        'strike-through': isTextStrikeThrough(aboveLineTax)
                    }"
                >
                    <div *ngIf="isRetailMinus" class="font-italic">
                        Applied
                    </div>
                    <div *ngIf="isCostPlus">
                        <div *ngIf="isCalculationTypePercentage(aboveLineTax)">
                            {{ aboveLineTax.value | decimalPrecision }}%
                        </div>
                        <div
                            *ngIf="isCalculationTypeFlatPerGallon(aboveLineTax)"
                        >
                            {{ aboveLineTax.amount | currencyPresicion }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-6 label-tax-fees">
                <div
                    [ngClass]="{
                        'strike-through': isTextStrikeThrough(aboveLineTax)
                    }"
                >
                    {{ aboveLineTax.name }}
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <hr
                    *ngIf="showLineSeparator"
                    style="margin-bottom: 10px; margin-top: 10px"
                />
            </div>
        </div>

        <!--Below the line taxes - Display mode 2-->
        <div *ngFor="let belowLineTax of belowTheLineTaxes" class="row">
            <div class="col-xl-6 label-tax-fees" style="padding-right: 0px">
                <div
                    [ngClass]="{
                        'strike-through': isTextStrikeThrough(belowLineTax)
                    }"
                    class=""
                >
                    <div *ngIf="isCalculationTypePercentage(belowLineTax)">
                        {{ belowLineTax.value | decimalPrecision }}%
                    </div>
                    <div
                        *ngIf="isCalculationTypeFlatPerGallon(belowLineTax)"
                    >
                        {{ belowLineTax.amount | decimalPrecision }}
                    </div>
                </div>
            </div>
            <div class="col-6 label-tax-fees" style="padding-right: 0px">
                <div
                    [ngClass]="{
                        'strike-through': isTextStrikeThrough(belowLineTax)
                    }"
                    class="no-padding-label"
                >
                    {{ belowLineTax.name }}
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="isPriceTaxBreakdown || isCustomerOmitting" class="container-fluid">
        <div class="row">
            <div class="col">
                <sub>C - Omitted for customer</sub>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <sub>P - Omitted for template</sub>
            </div>
        </div>
    </div>
</div>
